




















































































































































































































import { Component, Vue, Mixins } from "vue-property-decorator";
import MyList from "@/mixins/list";
import SelectStadium from "@/components/selectstadium.vue";
import Edit from "./Edit.vue";
import Charts from "./charts.vue";

@Component({
  components: {
    Edit,
    Charts,
    SelectStadium
  }
})
export default class extends Mixins(MyList) {
  dispatchType = "workorders/getWorkOrders";
  // dispatchTypeDelete: string = 'setting/delete'
  // deleteConfirmContent: string = '确认要删除该配置吗？'
  // page: number = 10
  // page_size: number = 10

  categories: any[] = [];

  editData: any = {};

  // 操作搜索栏的展开和折叠
  isFlag = false;

  columns: any[] = [
    {
      title: "编号",
      dataIndex: "id"
    },
    { title: "来源", scopedSlots: { customRender: "from_source" } },
    {
      title: "类型",
      dataIndex: "category_name"
    },
    { title: "头像", scopedSlots: { customRender: "avatar" } },
    {
      title: "用户名",
      scopedSlots: { customRender: "username" }
    },

    {
      title: "场馆",
      dataIndex: "stadium_name"
    },

    {
      title: "内容",
      scopedSlots: { customRender: "content" }
    },
    // {
    //   title: '用户类型',
    //   scopedSlots: { customRender: 'user_type' }
    // },

    {
      title: "状态",
      scopedSlots: { customRender: "status" }
    },
    {
      title: "创建时间",
      dataIndex: "created_time"
    },
    {
      title: "操作",
      width: 150,
      scopedSlots: { customRender: "action" }
    }
  ];

  mounted() {
    this.loadData({
      page_size: 10
    });

    this.loadCategories();
  }

  showEditModal1(id: number, record: any) {
    this.editId = id;
    this.editData = record;
    this.editModalVisible = true;
  }

  async loadCategories() {
    const res = await this.$store.dispatch("workorders/categoryselect", {});
    if (res && res.Data) {
      this.categories = res.Data;
    }
  }

  renderAnnouncement(content: string) {
    if (content.indexOf("|||") !== -1) {
      const arr: string[] = content.split("|||");
      return arr[1];
    }

    return content;
  }
}
